const errorCodes: Record<number | string, string> = {
  'error.auth.userNotFound': 'Nieprawidłowy e-mail lub hasło',
  'error.auth.credentials': 'Nieprawidłowy e-mail lub hasło',
  'error.auth.exist': 'E-mail jest już zajęty',
  401: 'Brak uprawnień',
  403: 'Dostęp zabroniony',
  404: '(404)Nie znaleziono',
  413: 'Za duży rozmiar pliku',
  500: 'Wewnętrzny błąd serwera'
}

const inputErrorCodes: Record<string, string> = {
  'error.email': 'Nieprawidłowy format email',
  'error.required': 'Pole zostało przesłane nieprawidłowo',
  'error.minLength8': 'Minimalna długość to 8 znaków',
  'error.telephone.invalid': 'Nieprawidłowy format telefonu'
}

export function getErrorResponse(code: number | string, key?: string) {
  if (key) return inputErrorCodes[code] || 'Wystąpił nieznany błąd'
  return errorCodes[code] || 'Wystąpił nieznany błąd'
}
